<template>
    <section v-if="uniqueBCLS.length > 0 && years.length > 0">
        <h2>Budget Expenditures</h2>
        <table v-cloak class="table table-striped">
            <thead>
                <th></th>
                <th v-for="year in this.years" :key="year">
                    {{ yearName(year) }}
                </th>
            </thead>
            <tr>
                <th>Expenditures:</th>
                <td v-for="year in this.years" :key="year">
                    {{ yearTotal(year) | toCurrency }}
                </td>
            </tr>
            <Row v-for="(bcl, index) in uniqueBCLS" 
                :key="department + '-' + index + '-' + bcl.name" 
                :name="bcl.name" 
                :children="filteredBudget(bcl)"
                :years="years"
            />
            <tr class="ftes">
                <th>FTEs:</th>
                <td v-for="year in this.years" :key="year">
                    {{ fteTotal(year).toFixed(2) }}
                </td>
            </tr>
        </table>
    </section>
</template>

<script>
    import Row from '@/components/Row';

    export default {
        name: 'Expenditures',
        props: {
            'department' : String,
            'years' : Array,
            'budget' : Array,
            'ftes' : Array
        },
        components: {
            Row
        },
        computed: {
            uniqueBCLS() {
                return this.getUniques(this.budget, 'bclname');
            },
        },
        methods: {
            getUniques(arr, prop) { /* Returns a trimmed array of properties */
                const uniques = [],
                    map = new Map();
                    
                for (const item of arr) {
                    if(!map.has(item[prop])){
                        map.set(item[prop], true);
                        uniques.push({
                            name: item[prop],
                        });
                    }
                }
                return uniques;
            },
            filteredBudget(bcl) {
                return this.budget.filter(child => {
                    return child.bclname == bcl.name;
                })
            },
            yearTotal(prop) {
                return this.budget.reduce((total, item) => {
                    return parseFloat(item[prop] || 0) + +total;
                }, 0);
            },
            fteTotal(prop) {
                return this.ftes.reduce((total, item) => {
                    return parseFloat(item[prop] || 0) + +total;
                }, 0);
            },
            yearName(prop) {
                let name = prop.split('_').join(' ');
                return name;
            }
        }
    }
</script>


<style scoped>
    .ftes th,
    .ftes td {
        padding-top:30px;
    }
    th {
        text-transform: capitalize;
    }
</style>
